import React, { Component } from 'react';
import InputFloating from './InputFloating.js';

export default class Typehead extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: '',
			open: false
		}
	}

	onSelection = (o, itm) => {
		this.setState({ value: itm, open: false });
		this.props.onSelection(o, false);
	}

	tryEntered = (e) => {
		if (e.keyCode === 13 || e.which === 13) {
			if (this.props.onPressingEnter) {
				this.setState({ value: '' }, this.props.onPressingEnter(e.target.value));
			}
		}
	}

	componentWillReceiveProps = (props) => {
		const { selected } = this.props;
		if (props.selected !== selected && props.selected == null) {
			this.setState({ value: '' });
		}
	}

	getFilteredResult = () => {
		const { options, valType, value, img } = this.props;
		if (!options) {
			return;
		}
		// eslint-disable-next-line
		return options.map((o, index) => {
			let itm = o;
			if (value) {
				let obs = value.split('.');
				obs.forEach(e => {
					itm = itm[e];
				})
			}
			if ((itm.toString().toLowerCase()).indexOf(this.state.value.toLowerCase()) !== -1) {
				if (valType && valType === 'product') {
					let i = o;
					if (img) {
						let obs = img.split('.');
						obs.forEach(e => {
							i = i[e];
						})
					}
					return (<li className={"dropdown-data-rec "} key={index} onClick={() => this.onSelection(o, itm)}>
						<div className="dropdown-data-rec-inner">
							<div className="row">
								<div className="col-xs-3" style={{ textAlign: 'center' }}>
									<img src={i} style={{ maxWidth: '100%', maxHeight: '40px' }} alt="product" />
								</div>
								<div className="col-xs-9">
									{itm}
								</div>
							</div>
						</div>
					</li>)
				} else {
					return <li className={"dropdown-data-rec "} key={index} onClick={() => this.onSelection(o, itm)}><div className="dropdown-data-rec-inner">{itm}</div></li>
				}
			}
		});
	}

	tryDoing = (e) => {
		this.setState({ value: e.target.value, open: true });
	}

	render() {
		const { props } = this;
		return (
			<div>
				<div style={{ position: 'relative' }}>
					<InputFloating type={props.type} className={props.className} id={props.id} label={props.placeholder} onChange={this.tryDoing} value={this.state.value} onKeyUp={this.tryEntered} />
					{(this.state.value && this.state.open) ?
						<div>
							<ul className="dropdown-menu rec-dropdown-new" style={{ display: 'block' }}>
								{this.getFilteredResult()}
							</ul>
						</div> : null
					}
				</div>
				{(props.required) ?
					<div className="requiredText">
						*Required
					</div> : null
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/commons/Typehead.js